/**
 * sp-cart-recommendations.js — Direkt-Hinzufügen der Warenkorb-Empfehlungen.
 * Custom-Element <sp-cart-recs> mit delegiertem Click-Handler auf [data-cart-rec-add].
 * Fügt die Variante per /cart/add.js hinzu, feuert das Theme-Event `cart:update`
 * (Drawer + Gratisversand-Balken hören darauf) und öffnet nichts extra (Kunde ist
 * schon im Warenkorb). Die Empfehlungsliste rendert danach serverseitig neu und
 * blendet den soeben hinzugefügten Artikel aus.
 */
(function () {
  'use strict';

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '');
  }

  class SpCartRecs extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this.addEventListener('click', this.onClick.bind(this));
    }

    async onClick(event) {
      var btn = event.target.closest('[data-cart-rec-add]');
      if (!btn || !this.contains(btn)) return;
      event.preventDefault();

      var id = btn.dataset.variantId;
      if (!id || btn.getAttribute('aria-busy') === 'true') return;

      var root = shopRoot();
      var sectionIds = Array.prototype.slice
        .call(document.querySelectorAll('cart-items-component'))
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      var body = { items: [{ id: id, quantity: 1 }] };
      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }

      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      try {
        var res = await fetch(root + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        var data = await res.json();

        if (res.ok && !data.status) {
          var cart = null;
          try {
            cart = await (await fetch(root + '/cart.js', { headers: { Accept: 'application/json' } })).json();
          } catch (e) {
            /* Balken hat eigenen Fallback */
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'sp-cart-recs',
                data: {
                  source: 'sp-cart-recs',
                  itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 1,
                  sections: data.sections,
                },
              },
            })
          );
          // Kein Drawer-Open nötig – Kunde ist bereits im Warenkorb; die Liste rendert
          // durch das cart:update serverseitig neu (Artikel verschwindet aus den Recs).
        }
      } catch (e) {
        /* Netzwerkfehler – Button wird unten wieder aktiviert */
      } finally {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }
    }
  }

  if (!customElements.get('sp-cart-recs')) {
    customElements.define('sp-cart-recs', SpCartRecs);
  }
})();
